import {
    ISimplePresentation,
    ISimplePresentationRunnerController
} from "../../core/winpresentation/SimplePresentationRunner";
import {DjPsycho} from "../DjPsycho";
import {TimelineLite} from "gsap";

export class DjPsychoTotalWinRunner implements ISimplePresentation {

    public shouldRun(): boolean {
        return DjPsycho.model.gameData.totalSpinRoundWinnings > 0 && (DjPsycho.model.endOfAvalanche(DjPsycho.model.data.mode, DjPsycho.model.data.nextMode) && DjPsycho.model.winRatio < 15);
    }

    public start(controller: ISimplePresentationRunnerController): void {
        const winAmount: number = DjPsycho.model.gameData.totalSpinRoundWinnings,
            tl: TimelineLite = new TimelineLite({
                delay: 0.2,
                onComplete: () => {
                    this.complete(controller);
                }
            });

        tl.add([
            () => {
                controller.setSkipCallback(() => {
                    this.onSkip();
                });
            },
            DjPsycho.totalWinView.getTotalWinTimeline(winAmount)
        ], 0);
    }

    private complete(controller: ISimplePresentationRunnerController): void {
        controller.finish();
    }

    private onSkip(): void {
        DjPsycho.totalWinView.hardAbort();
    }
}